import make from "./coatingAreaFactory";
import calculateLiterage from "./lib/coatingCalculator";

export default {
  namespaced: true,

  state: {
    exteriorAreas: [],
    interiorAreas: [],
  },

  getters: {
    totalExteriorQuantity: ({ exteriorAreas }) =>
      calculateLiterage(exteriorAreas),
    totalInteriorQuantity: ({ interiorAreas }) =>
      calculateLiterage(interiorAreas),
  },

  mutations: {
    addInteriorArea(state, payload) {
      state.interiorAreas.push(make(payload.type));
    },
    removeInteriorArea(state, payload) {
      state.interiorAreas.splice(payload.index, 1);
    },
    updateInteriorArea(state, payload) {
      state.interiorAreas.splice(payload.index, 1, payload.area);
    },
    addExteriorArea(state, payload) {
      state.exteriorAreas.push(make(payload.type));
    },
    removeExteriorArea(state, payload) {
      state.exteriorAreas.splice(payload.index, 1);
    },
    updateExteriorArea(state, payload) {
      state.exteriorAreas.splice(payload.index, 1, payload.area);
    },
  },
};
